<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
  <Teleport to="body">
    <FlowbiteModal
      v-if="visible"
      class="modals"
      :size="size"
      :escapable="escapable"
      @close="handleClose"
      @keydown.esc.stop.prevent="handleClose"
    >
      <template #header>
        <slot name="header"></slot>
      </template>
      <template #body>
        <slot name="body"></slot>
      </template>
      <template #footer>
        <slot name="footer"></slot>
      </template>
    </FlowbiteModal>
  </Teleport>
</template>

<script setup lang="ts">
import { Modal as FlowbiteModal } from 'flowbite-vue'

interface Props {
  visible: boolean
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl'
  escapable?: boolean
}

withDefaults(defineProps<Props>(), {
  size: '2xl',
  escapable: false
})

const emit = defineEmits<{
  close: []
}>()

const handleClose = () => {
  emit('close')
}
</script>

<style scoped>
.modals {
  z-index: 20000;
}

/* モバイルでモーダルがヘッダーと重ならないように位置調整 */
@media (max-width: 768px) {
  /* 背景オーバーレイは全画面に表示 */
  .modals :deep(.fixed.inset-0.z-40) {
    top: 0 !important;
  }

  /* モーダル本体をヘッダー下に配置 */
  .modals :deep(.fixed.inset-0.z-50) {
    top: 68px !important;
    height: calc(100vh - 68px) !important;
    padding-top: 0 !important;
  }

  /* モーダルコンテンツの調整 */
  .modals :deep(.flex.items-center.justify-center) {
    align-items: flex-start !important;
    padding-top: 1rem !important;
  }
}
</style>
